import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateJobQueryKeys } from '@/modules/candidates/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface InterviewCandidateJobParams {
  jobId: string;
  candidateId: string;
}

export const useInterviewCandidateJobMutation = () => {
  return useMutation({
    mutationFn: ({ jobId, candidateId }: InterviewCandidateJobParams) =>
      fetchClient.POST('/jobs/{jobId}/candidates/{candidateId}/interview', {
        params: {
          path: {
            jobId,
            candidateId,
          },
        },
      }),
    onSettled: (_data, _error, variables) => {
      const { jobId, candidateId } = variables;
      const detailQueryKey = candidateJobQueryKeys.detail(jobId, candidateId);
      const listQueryKey = candidateJobQueryKeys.lists(jobId);

      invalidateQuery(listQueryKey)();
      invalidateQuery(detailQueryKey)();
    },
  });
};
